import { render } from "./process-report-1.vue?vue&type=template&id=18355505"
import script from "./process-report-1.vue?vue&type=script&lang=js"
export * from "./process-report-1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__